module.exports = __webpack_public_path__ + "static/media/abantub.5e0af1f1.png";